/****

DEPRECATED: We are no longer using vuelidate, we have integrated validations in
GInput and GForm that can be fully customized as needed, use that instead.

****/
import { isValidEmail as email, isUsPhone as phoneNumber } from '@consumer/services/validation'
import { useVuelidate } from '@vuelidate/core'
import { and, helpers, sameAs } from '@vuelidate/validators'

export type { ErrorObject } from '@vuelidate/core'
export { and, email, phoneNumber, sameAs, useVuelidate as useValidation }

export const withAsync = helpers.withAsync
export const withMessage = helpers.withMessage

export const required = helpers.withMessage(
  'This field cannot be empty',
  (value?: any) => typeof value === 'boolean' ? value : helpers.req(value),
)

export const requiredEmail = withMessage('Please enter a valid email address', and(withAsync(email), required))

export const requiredPhoneNumber = withMessage('Please enter a valid phone number', and(phoneNumber, required))

export const zipCode = (number?: string) => !!number?.match(/^\d{5}$/)

export const internationalPhoneNumber = (number?: string) => helpers.req(number)
  && (number ?? '')?.replace(/[^0-9]/g, '').length >= 10

export const requiredInternationalPhoneNumber = withMessage(
  'Please enter a valid phone number',
  and(internationalPhoneNumber, required),
)

export const isValidPhone = (number?: string) => helpers.req(number) && number?.replace(/[^0-9]/g, '').length === 10
